import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter022() {
  return <KbChapterPage slug="chapter-022" />;
}

(Chapter022 as unknown as { path: string }).path = "/theory-album/022";
